import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import en from './locales/en.json'
import ja from './locales/ja.json'
import mixins from './mixins/globalValiables' 

// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const vuetify = createVuetify({
  components,
  directives,
})

const i18n = createI18n({
    locale: 'ja', // デフォルトの言語を設定します
    messages: {
      en: en,
      ja: ja
    }
  })

createApp(App).use(store).use(router).use(vuetify).use(VueAxios,axios).use(i18n).mixin(mixins).mount('#app')
